'use client'
import React, {createContext, useEffect, useState} from 'react';
import {ChakraProvider} from '@chakra-ui/react';
import theme from './theme/chakra.theme';
import { MenuContext } from './menuContext';

const MENU_COLLAPSE_STORAGE_KEY = 'menu:isCollapsed';

export default function MenuProvider({children}) {
  const getInitialCollapsedState = () => {
    if (typeof window === 'undefined') {
      return false;
    }

    const persistedState = window.localStorage.getItem(MENU_COLLAPSE_STORAGE_KEY);

    if (persistedState === null) {
      return false;
    }

    return persistedState === 'true';
  };

  const [visibility, setVisibility] = useState(true)
  const [isCollapsed, setIsCollapsed] = useState(getInitialCollapsedState)

  useEffect(() => {
    window.localStorage.setItem(MENU_COLLAPSE_STORAGE_KEY, String(isCollapsed));
  }, [isCollapsed]);

  const toggleVisibility = () => {
    setVisibility(!visibility)
  }
  const close = () => {
    setVisibility(false);
  }
  const open = () => {
    setVisibility(true);
  }
  const collapse = () => {
    setIsCollapsed(true);
  }
  const expand = () => {
    setIsCollapsed(false);
  }
  const toggleCollapse = () => {
    setIsCollapsed(!isCollapsed);
  }
  return (
    <MenuContext.Provider value={{
      visibility,
      isCollapsed,
      toggleVisibility: toggleVisibility,
      close,
      open,
      collapse,
      expand,
      toggleCollapse
    }}>
        {children}
    </MenuContext.Provider>
  );
}
